import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';

export const commonStyles = StyleSheet.create({
  cartEntryBody: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$bbqBrown,
  },
  cartEntryItemName: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$bbqBrown,
  },
  withBorderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
});
